import axios from "../axios";
import errorHandler from "../error-handler";

export const getCountyList = ({ page, size, search }) =>
    new Promise((resolve, reject) =>
        axios
            .get(`/geo/counties`, {
                params: { page, size, search }
            })
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const updateCounty = (id, data) =>
    new Promise((resolve, reject) =>
        axios
            .put(`/geo/counties/${id}`, data)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const getMunicipalityList = ({ page, size, search }) =>
    new Promise((resolve, reject) =>
        axios
            .get(`/geo/municipalities`, {
                params: { page, size, search }
            })
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );


    export const getMunicipalityListByYear = ({ year }) =>
        new Promise((resolve, reject) =>
            axios
                .get(`/geo/municipalities/${year}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(errorHandler(error)))
        );

export const updateMunicipality = (number, data) =>
    new Promise((resolve, reject) =>
        axios
            .put(`/geo/municipalities/${number}`, data)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const getZipCodeList = ({ page, size, search }) =>
    new Promise((resolve, reject) =>
        axios
            .get(`/geo/zip_codes`, {
                params: { page, size, search }
            })
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const updateZipCode = (number, data) =>
    new Promise((resolve, reject) =>
        axios
            .put(`/geo/zip_codes/${number}`, data)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );
